var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerifiedStudent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6Zm8.595-1.81a.556.556 0 1 0-.746-.824c-.738.67-1.293 1.272-1.761 2.003-.341.532-.628 1.12-.91 1.833L4.177 6.169a.556.556 0 0 0-.798.773L4.995 8.61a.556.556 0 0 0 .924-.204c.373-1.073.705-1.813 1.104-2.437.397-.62.877-1.147 1.572-1.779Z",
  fill: "#4ADE80"
})));
export default SvgVerifiedStudent;